"use client";

import {
  Dumbbell,
  Medal,
  Target,
  Timer,
  Trophy,
  Volleyball,
  Waves,
  Zap,
} from "lucide-react";

interface WatermarkIcon {
  Icon: typeof Dumbbell;
  top: string;
  left: string;
  size: number;
  rotate: number;
}

const ICONS: WatermarkIcon[] = [
  { Icon: Trophy, top: "6%", left: "8%", size: 140, rotate: -12 },
  { Icon: Volleyball, top: "58%", left: "4%", size: 110, rotate: 8 },
  { Icon: Dumbbell, top: "78%", left: "62%", size: 130, rotate: -6 },
  { Icon: Target, top: "10%", left: "68%", size: 100, rotate: 15 },
  { Icon: Medal, top: "38%", left: "80%", size: 120, rotate: -10 },
  { Icon: Timer, top: "4%", left: "42%", size: 90, rotate: 20 },
  { Icon: Waves, top: "68%", left: "30%", size: 110, rotate: -18 },
  { Icon: Zap, top: "28%", left: "20%", size: 80, rotate: 25 },
];

/** Line-art sports iconography scattered at very low opacity, per the design
 * system's "stadium energy" brand requirement. Pure CSS/SVG - zero image
 * requests, safe to render behind dense content. */
export function SportWatermark({ className }: { className?: string }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className ?? ""}`} aria-hidden>
      {ICONS.map(({ Icon, top, left, size, rotate }, i) => (
        <Icon
          key={i}
          style={{
            position: "absolute",
            top,
            left,
            width: size,
            height: size,
            transform: `rotate(${rotate}deg)`,
          }}
          className="text-white/[0.06] stroke-[0.75]"
        />
      ))}
    </div>
  );
}
